import React, { useMemo, useState } from "react";
import DarkTable from "components/Table/DarkTable";
import { useData } from "hooks/useData";
import { packetsMock } from "mocks/packetsMock";
import { parseDateWithMicrosecondsToSeconds } from "utils";

import { useGetPacketsQuery } from "store/apiSlice";
import { Icon } from "@rsuite/icons";
import { ArrowRightLine, ArrowLeftLine } from "@rsuite/icons";

type CallsPacketTableProps = {
    callId: number | null;
    callData: Record<string, any> | null;
    callsLoading: boolean;
};


const CallsPacketsTable: React.FC<CallsPacketTableProps> = ({ callId, callData, callsLoading }) => {
    const { data: packets, isLoading, isFetching, error, refetch } = useData(
        useGetPacketsQuery,
        packetsMock,
        { 
            call_id: callId!
        },
        !callId
    );

    const firstPacket = useMemo(() => {
        return !!packets && packets.length ? packets[0] : null;
    }, [packets]);

    const columns = [
        { 
            label: "Date/time",
            dataKey: "time",
            minWidth: 220,
            flexGrow: 1,
            align: "left",
            resizable: false
        },
        { 
            label: "Session time",
            dataKey: "session_time",
            value: ({time}: any) => {
                const sessionTime = parseDateWithMicrosecondsToSeconds(firstPacket.time);
                const currentTime = parseDateWithMicrosecondsToSeconds(time);
                const diff = (currentTime - sessionTime).toFixed(6);

                return diff;
            },
            minWidth: 120,
            // flexGrow: 1,
            align: "right",
            resizable: false
        },
        {
            label: "Incoming IP",
            dataKey: "ip_src",
            value: ({ ip_src, port_src }: any) => {
                return `${ip_src}:${port_src}`;
            },
            minWidth: 180,
            flexGrow: 1,
            align: "left",
            resizable: false
        },
        {
            label: "Outgoing IP",
            dataKey: "ip_dst",
            value: ({ ip_dst, port_dst }: any) => {
                return `${ip_dst}:${port_dst}`;
            },
            minWidth: 180,
            flexGrow: 1,
            align: "left",
            resizable: false
        },
        {
            label: "Direction",
            dataKey: "ip_src",
            value: ({ ip_src }: any) => {
                const callIpSrc = callData?.ip_src;
                const direction = ip_src === callIpSrc; // true if incoming, false if outgoing

                return direction ? <>
                    <Icon as={ArrowRightLine} />
                </> : <>
                    <Icon as={ArrowLeftLine} />
                </>;
            },
            width: 80,
            align: "center",
            resizable: false
        },
        {
            label: "Method/Code",
            dataKey: "method_code",
            // minWidth: 300,
            flexGrow: 2,
            align: "left",
            resizable: false
        }
    ];

    const packetsLoading = isLoading || isFetching;
    const loading = packetsLoading || callsLoading;

    const shouldClearPackets = !callId || loading;
    const data = shouldClearPackets ? [] : packets;

    return <>
        <DarkTable
            data={data}
            columns={columns}
            title="Packets"
            loading={packetsLoading}
            error={error}
            showSkeleton
            // showError
            rowHeight={40}
            headerHeight={40}
            height={380}
            skeletonRows={8}
            // autoHeight
            bordered
            cellBordered
        />
    </>;
};

export default CallsPacketsTable;